<template>
    <section class="tekst light purple">
        <circles-layout></circles-layout>
        <h1>Dit hebben we bereikt in 2020</h1>
        <p>In het uitdagende jaar 2020 hebben we de onderwijskwaliteit overeind weten te houden. Gesteund door de digitale wereld, maar vooral dankzij de kracht van studenten en medewerkers. Hun creativiteit, flexibiliteit en betrokkenheid zorgden ervoor dat de student centraler stond dan ooit tevoren.</p>

        <p>Het beste onderwijs van Nederland verzorgen. Aan die ambitie van Onderwijsgroep Tilburg levert het Studenten Adviespunt 013 (STAP 013) een belangrijke bijdrage. Het is sinds 2020 dé plek voor leerlingen, studenten en medewerkers met vragen over voorlichting, werving, opleidingen, aanmelding, inschrijving, studieadvies en andere schooloverstijgende zaken.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'BereiktIntro',
        meta: {
            title: 'BereiktIntro',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
            }
        }
    };
</script>
